module.exports = __webpack_public_path__ + "img/applet-sales1.9cecd648.png";